import React from "react";

import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import Badge from "src/root/pages/images/leader_winter_2023.png";
import LoginImage from "Vendor_resources/images/signin_art_desktop.png";

import * as S from "../styles";

const DefaultLogin = () => {
  const intl = useIntl();

  return (
    <S.LeftPane backgroundImage={LoginImage}>
      {Badge && (
        <S.LeftPaneTitle>
          <img src={Badge} alt="Leader winter 2023 " />
          <S.LeaderFall>
            {intl.formatMessage({ id: "customer_g2" }, { app_name: APP_NAME })}
          </S.LeaderFall>
        </S.LeftPaneTitle>
      )}
    </S.LeftPane>
  );
};

export default DefaultLogin;
